angular.module('trainerWebApp.resources').factory('CustomEmailResource', ['$resource', 'errorHandler', function ($resource, errorHandler) {

    var CustomEmailResource = $resource();
    var CoursePreviewEmailResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/email/:emailType/:preview');
    var CourseEmailResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/email/:emailType');

    ///course ////
    CustomEmailResource.prototype.getCourseEmails = function (courseId, resultCb, errorCb) {
        if (!this.validId(courseId))
            throw new Error("Course id is invalid.");

        return CourseEmailResource.get({courseId: courseId}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    ////series////
    CustomEmailResource.prototype.getSeriesEmail = function (courseId, resultCb, errorCb) {
        if (!this.validId(courseId))
            throw new Error("Series id is invalid.");

        return CoursePreviewEmailResource.get({courseId: courseId}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomEmailResource.prototype.previewCompletion = function (courseId, customText, resultCb, errorCb) {
        if (!this.validId(courseId))
            throw new Error("Series id is invalid.");
        return CoursePreviewEmailResource.save({courseId: courseId, emailType: 'courseCompletion', preview: 'preview'}, {customText: customText}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomEmailResource.prototype.previewInvitation = function (courseId, customText, resultCb, errorCb) {
        if (!this.validId(courseId))
            throw new Error("Series id is invalid.");

        return CoursePreviewEmailResource.save({courseId: courseId, emailType: 'courseInvitation', preview: 'preview'}, {customText: customText}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomEmailResource.prototype.previewReminder = function (courseId, customText, resultCb, errorCb) {
        if (!this.validId(courseId))
            throw new Error("Series id is invalid.");

        return CoursePreviewEmailResource.save({courseId: courseId, emailType: 'courseReminder', preview: 'preview'}, {customText: customText}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomEmailResource.prototype.updateCompletion = function (courseId, customText, resultCb, errorCb) {
        if (!this.validId(courseId))
            throw new Error("Course or Series id is invalid.");

        return CourseEmailResource.save({courseId: courseId, emailType: 'seriesCompletion'}, {customText: customText}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomEmailResource.prototype.updateInvitation = function (courseId, customText, resultCb, errorCb) {
        if (!this.validId(courseId))
            throw new Error("Course or Series id is invalid.");

        return CourseEmailResource.save({courseId: courseId, emailType: 'seriesInvitation'}, {customText: customText}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomEmailResource.prototype.updateReminder = function (courseId, customText, resultCb, errorCb) {
        if (!this.validId(courseId))
            throw new Error("Course or Series id is invalid.");

        return CourseEmailResource.save({courseId: courseId, emailType: 'seriesReminder'}, {customText: customText}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    CustomEmailResource.prototype.emailTypes = ['courseCompletion', 'courseInvitation', 'courseReminder', 'seriesCompletion', 'seriesInvitation', 'seriesReminder'];

    CustomEmailResource.prototype.validId = function (value) {
        value = +value;
        if (isNaN(value)) return false;
        if (!angular.isNumber(value)) return false;
        if (value <= 0) return false;
        return true;
    };

    return new CustomEmailResource;
}]);
